export default "__VITE_ASSET__oEGOSzlX__"